import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import { CurrentUserManager } from 'managers/currentUser';
import { IWCCStorageManager } from 'managers/iStorage';
import TopicPeopleTagsManager from 'managers/tags/topicPeople';
import { Person } from 'models/person';
import { Tag } from 'models/tag';
import { TopicThread } from 'models/topicThread';
import './visibilityTags.html';
import './visibilityTags.scss';

export interface CommentVisibilitTagsVMCofig {
    comment?: SubscribableOrNullableValue<TopicThread>
}

@injectable()
export default class CommentVisibilitTagsVM {
    private topicId: Subscribable<string | undefined>
    private user: Subscribable<Person | undefined>

    label = `${labels.VisibleTo}:`

    tags: Subscribable<Array<Tag>>

    isActive: Subscribable<boolean>
    isLoading: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: CommentVisibilitTagsVMCofig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager
    ) {
        const comment = ko.flattenComputed(config.comment);
        this.topicId = comment.pluck('topicId');
        const isForTaggedPeople = comment.pluck('isForTaggedPeople', false);
        const commentVisibilityTagIDs = comment.pluck('threadVisibilityTagIDs', []);

        const userManager = storage.get(CurrentUserManager, { discussionId: settings.discussionId });
        this.user = userManager.pluck('person');
        const isModeratorOrObserver = this.user.pluck('isModeratorOrObserver', false);

        const tagsManager = storage.get(TopicPeopleTagsManager, [this.topicId]);
        const tags = tagsManager.pluck('tags', []);

        this.isLoading = tagsManager.pluck('loading', true);
        this.tags = tags.filter(tag => commentVisibilityTagIDs().includes(tag.contentTagId() ?? ''));

        this.isActive = ko.pureComputed(() => isForTaggedPeople() && isModeratorOrObserver() && commentVisibilityTagIDs().length > 0);

        ko.applyBindingsToNode(info.element, {
            'visible': this.isActive,

            'css': {
                'topic__comment__visibility-tags': true
            }
        }, this);
    }
}